// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"322":"88b28c8e","381":"7a468916","408":"3cc85f7d","465":"967ce6d5","608":"42415a74"}[chunkId] + ".chunk.js";
};